import $http from './http'
import config from './config'

export default {
  name: 'work',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getWorkTasks(data) {
    return $http.post(this.getUrl(`/WorkTask/GetWorkTasks`), data);
  },
  TaskResolve(id, options) {
    return $http.get(this.getUrl(`/WorkTask/Resolve/${id}`), options)
  },
  TaskReject(id, options) {
    return $http.get(this.getUrl(`/WorkTask/Reject/${id}`), options)
  },
  List(data) {
    return $http.post(this.getUrl(`/WorkTask/List`), data);
  },
}



// WEBPACK FOOTER //
// ./src/apis/workApis.js